import React from "react";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";

import { Box, Chip, Grid, MenuItem, Paper, Select, useTheme } from "@mui/material";

import {
  getSaleStatus,
  isValidJSON,
  getProductType,
  parseSaleNote,
} from "./utils/applibs";
import JsonViewer from "./utils/JsonViewer";

const AdminSale = (props) => {
  const theme = useTheme();

  const styles = {
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    marginRight: {
      marginRight: theme.spacing(1.25),
    },
    fullWidth: { width: "100%" },
    grid: {
      padding: theme.spacing(1.25),
    },
    actions: {
      display: "flex",
      justifyContent: "space-around",
      marginTop: theme.spacing(5),
      padding: "10px 0",
    },
  };

  const {
    canEdit,
    saleId,
    created,
    productName,
    onProductNameChange,
    productType,
    onProductTypeChange,
    status,
    onStatusChange,
    saleNote,
    onNoteChange,
    productId,
    onProductIdChange,
    currency,
    onCurrencyChange,
    amount,
    onAmountChange,
    saleNb,
    onNbChange,
    refnumber,
    onRefnumberChange,
    paymentMethodName,
    onChangePaymentMethodName,
    paymentMethod,
    onPaymentMethodChange,
    saleUppTransactionNumber,
    onChangeSaleUppTransactionNumber,
    saleNotif,
    onSaleNotifChange,
    referer,
    onRefererChange,
    submitting,
    handlePostItem,
    onCancelAction,
    userEmail,
    stripeData,
    stripeLoading,
    stripeError,
    onStripeSearch,
  } = props;

  const [stripeEmailInput, setStripeEmailInput] = React.useState(userEmail || "");

  const saleNotifJSON = isValidJSON(saleNotif)
    ? JSON.parse(saleNotif || "{}")
    : saleNotif;

  const paymentMethods = [
    { key: 3, value: "STRIPE" },
    { key: 1, value: "DATATRANS" },
  ];

  const paymentMethodStr =
    (paymentMethods.find((p) => p.key === parseInt(paymentMethod, 10)) || {})
      .value || "n/a";

  return (
    <React.Fragment>
      <div style={styles.root}>
        <form noValidate autoComplete="off">
          <Grid container spacing={3}>
            <Grid md={6} item xs={12}>
              <Paper style={styles.grid} spacing={3}>
                <TextField
                  style={styles.marginRight}
                  label="Id Vente"
                  margin="normal"
                  variant="outlined"
                  value={saleId}
                />
                <TextField
                  style={styles.marginRight}
                  label="Id Article"
                  margin="normal"
                  variant="outlined"
                  value={productId}
                  onChange={onProductIdChange}
                />
                <FormControl fullWidth>
                  <TextField
                    label="Produit"
                    margin="normal"
                    variant="outlined"
                    value={productName}
                    onChange={onProductNameChange}
                  />
                </FormControl>
                <div style={styles.fullWidth}>
                  <TextField
                    style={styles.marginRight}
                    label="Unité"
                    margin="normal"
                    variant="outlined"
                    value={saleNb}
                    onChange={onNbChange}
                  />
                  <TextField
                    style={styles.marginRight}
                    label="Montant"
                    margin="normal"
                    variant="outlined"
                    value={amount}
                    onChange={onAmountChange}
                  />
                  <TextField
                    style={styles.marginRight}
                    label="Devise"
                    margin="normal"
                    variant="outlined"
                    value={currency}
                    onChange={onCurrencyChange}
                  />
                  <TextField
                    label="Methode de paiement"
                    margin="normal"
                    variant="outlined"
                    value={paymentMethodStr}
                    onChange={onPaymentMethodChange}
                  />
                  <FormControl fullWidth>
                    <TextField
                      label="Transaction 3rd party (saleUppTransactionNumber)"
                      margin="normal"
                      variant="outlined"
                      value={saleUppTransactionNumber}
                      onChange={onChangeSaleUppTransactionNumber}
                    />
                  </FormControl>
                </div>
              </Paper>
            </Grid>
            <Grid md={6} item xs={12}>
              <Paper style={styles.grid} spacing={3}>
                <TextField
                  fullWidth
                  style={styles.marginRight}
                  label="Transaction interne"
                  margin="normal"
                  variant="outlined"
                  value={refnumber}
                  onChange={onRefnumberChange}
                />

                <Select
                  fullWidth
                  style={styles.marginRight}
                  labelId="payment-method-select-label"
                  id="payment-method-select"
                  value={paymentMethodName}
                  label="Payment method"
                  onChange={onChangePaymentMethodName}
                >
                  <MenuItem value={0}>Aucun</MenuItem>
                  <MenuItem value={"twint"}>Twint</MenuItem>
                  <MenuItem value={"mastercard"}>Card (Mastercard)</MenuItem>
                  <MenuItem value={"visa"}>Card (VISA)</MenuItem>
                  <MenuItem value={"link"}>Card (Link)</MenuItem>
                </Select>

                <TextField
                  style={styles.marginRight}
                  label="Crée le"
                  margin="normal"
                  variant="outlined"
                  value={created}
                  disabled={true}
                />

                <TextField
                  style={styles.marginRight}
                  label="Type de produit"
                  margin="normal"
                  onChange={onProductTypeChange}
                  variant="outlined"
                  value={getProductType(productType)}
                />
                <TextField
                  style={styles.marginRight}
                  label="Status"
                  margin="normal"
                  onChange={onStatusChange}
                  variant="outlined"
                  value={getSaleStatus(status)}
                />
                <TextField
                  style={styles.marginRight}
                  label="Information"
                  margin="normal"
                  onChange={onNoteChange}
                  variant="outlined"
                  value={parseSaleNote(saleNote)}
                />
                <FormControl fullWidth>
                  <TextField
                    label="Plateforme"
                    margin="normal"
                    variant="outlined"
                    value={referer}
                    onChange={onRefererChange}
                  />
                </FormControl>
              </Paper>
            </Grid>

            <Grid md={12} item xs={12}>
              <Paper style={styles.grid} spacing={3}>
                <FormControl fullWidth>
                  {saleNotifJSON.payment_intent || saleNotifJSON.livemode ? (
                    <JsonViewer src={saleNotifJSON} collapsed={true} />
                  ) : (
                    <TextField
                      label="Notif 3rd-party"
                      margin="normal"
                      variant="outlined"
                      value={JSON.stringify(saleNotifJSON)}
                      onChange={onSaleNotifChange}
                    />
                  )}
                </FormControl>
              </Paper>
            </Grid>

            <Grid md={12} item xs={12}>
              <Paper style={styles.grid} spacing={3}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                  <Chip label="Stripe" color="primary" size="small" />
                  <TextField
                    label="Email client"
                    variant="outlined"
                    size="small"
                    value={stripeEmailInput}
                    onChange={(e) => setStripeEmailInput(e.target.value)}
                    sx={{ flex: 1, minWidth: 240 }}
                  />
                  <Button
                    variant="outlined"
                    disabled={stripeLoading || !stripeEmailInput}
                    onClick={() => onStripeSearch(stripeEmailInput)}
                    startIcon={stripeLoading ? <CircularProgress size={16} /> : null}
                  >
                    {stripeLoading ? "Recherche..." : "Rechercher sur Stripe"}
                  </Button>
                </Box>

                {stripeError && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    {stripeError}
                  </Alert>
                )}

                {stripeData && !stripeLoading && (
                  <Box sx={{ mt: 2 }}>
                    <JsonViewer src={stripeData} collapsed={false} />
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>

          <div style={styles.actions}>
            {canEdit || true ? (
              <Button
                variant="contained"
                disabled={submitting}
                onClick={handlePostItem}
              >
                {submitting ? "processing ..." : "Sauver"}
              </Button>
            ) : null}

            <Button
              variant="contained"
              disabled={submitting}
              onClick={onCancelAction}
            >
              Annuler
            </Button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

export default AdminSale;
